import { render } from "./DetailLevelInventoryList.vue?vue&type=template&id=f2d1c8fe&scoped=true&ts=true"
import script from "./DetailLevelInventoryList.vue?vue&type=script&lang=ts"
export * from "./DetailLevelInventoryList.vue?vue&type=script&lang=ts"

import "./DetailLevelInventoryList.vue?vue&type=style&index=0&id=f2d1c8fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2d1c8fe"]])

export default __exports__